import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  
  loadCookieScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.charset = 'UTF-8';
    script.setAttribute('data-domain-script', environment.cookieDomainScript);

    document.head.appendChild(script);

    const optanonScript = document.createElement('script');
    optanonScript.type = 'text/javascript';
    optanonScript.text = 
    `function OptanonWrapper() {
      const activeGroups = window.OnetrustActiveGroups || '';
       const analyticsConsent = activeGroups.includes('C0002');
       window.dataLayer = window.dataLayer || [];
       function gtag(){dataLayer.push(arguments);}
       gtag('consent', 'update', {
         'analytics_storage': analyticsConsent ? 'granted' : 'denied'
       });
    }`;
    document.head.appendChild(optanonScript);
  }

}
